import { __awaiter, __decorate, __extends, __generator } from "tslib";
import { attachShadowTemplate, coerceBoolean, CustomElement, ensureChildren, FoundationProperty, upgradeProperty } from '@tyler-components-web/core';
import { StepComponent } from '../step/step';
import { StepperAdapter } from './stepper-adapter';
import { STEPPER_CONSTANTS } from './stepper-constants';
import { StepperFoundation } from './stepper-foundation';
var template = require('./stepper.html');
var styles = require('./stepper.css');
var StepperComponent = /** @class */ (function (_super) {
    __extends(StepperComponent, _super);
    function StepperComponent() {
        var _this = _super.call(this) || this;
        attachShadowTemplate(_this, STEPPER_CONSTANTS.elementName, template, styles);
        _this._foundation = new StepperFoundation(new StepperAdapter(_this));
        return _this;
    }
    Object.defineProperty(StepperComponent, "observedAttributes", {
        get: function () {
            return [
                STEPPER_CONSTANTS.attributes.SELECTED_INDEX,
                STEPPER_CONSTANTS.attributes.LINEAR,
                STEPPER_CONSTANTS.attributes.ALTERNATIVE,
                STEPPER_CONSTANTS.attributes.LAYOUT_MODE,
                STEPPER_CONSTANTS.attributes.LAYOUT_ALIGN,
                STEPPER_CONSTANTS.attributes.DISABLED,
                STEPPER_CONSTANTS.attributes.VERTICAL,
            ];
        },
        enumerable: true,
        configurable: true
    });
    StepperComponent.prototype.initializedCallback = function () {
        upgradeProperty(this, 'steps');
        upgradeProperty(this, 'selectedIndex');
        upgradeProperty(this, 'linear');
        upgradeProperty(this, 'alternative');
        upgradeProperty(this, 'layoutMode');
        upgradeProperty(this, 'layoutAlign');
        upgradeProperty(this, 'disabled');
        upgradeProperty(this, 'vertical');
    };
    StepperComponent.prototype.connectedCallback = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, ensureChildren(this)];
                    case 1:
                        _a.sent();
                        this._foundation.initialize();
                        return [2 /*return*/];
                }
            });
        });
    };
    StepperComponent.prototype.disconnectedCallback = function () {
        this._foundation.disconnect();
    };
    StepperComponent.prototype.attributeChangedCallback = function (name, oldValue, newValue) {
        switch (name) {
            case STEPPER_CONSTANTS.attributes.SELECTED_INDEX:
                this.selectedIndex = Number(newValue) || 0;
                break;
            case STEPPER_CONSTANTS.attributes.LINEAR:
                this.linear = coerceBoolean(newValue);
                break;
            case STEPPER_CONSTANTS.attributes.ALTERNATIVE:
                this.alternative = coerceBoolean(newValue);
                break;
            case STEPPER_CONSTANTS.attributes.LAYOUT_MODE:
                this.layoutMode = newValue;
                break;
            case STEPPER_CONSTANTS.attributes.LAYOUT_ALIGN:
                this.layoutAlign = newValue;
                break;
            case STEPPER_CONSTANTS.attributes.DISABLED:
                this.disabled = coerceBoolean(newValue);
                break;
            case STEPPER_CONSTANTS.attributes.VERTICAL:
                this.vertical = this.hasAttribute(STEPPER_CONSTANTS.attributes.VERTICAL);
                break;
        }
    };
    Object.defineProperty(StepperComponent.prototype, "steps", {
        /** The step configurations. */
        get: function () {
            return this._foundation.steps;
        },
        set: function (value) {
            this._foundation.steps = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StepperComponent.prototype, "selectedIndex", {
        /** The active step index. */
        get: function () {
            return this._foundation.selectedIndex;
        },
        set: function (value) {
            this._foundation.selectedIndex = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StepperComponent.prototype, "linear", {
        /** Whether the stepper is linear or non-linear. */
        get: function () {
            return this._foundation.linear;
        },
        set: function (value) {
            this._foundation.linear = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StepperComponent.prototype, "alternative", {
        /** Whether the stepper uses the default or alternative label layout mode. */
        get: function () {
            return this._foundation.alternative;
        },
        set: function (value) {
            this._foundation.alternative = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StepperComponent.prototype, "layoutMode", {
        /** The layout mode of the stepper. */
        get: function () {
            return this._foundation.layoutMode;
        },
        set: function (value) {
            this._foundation.layoutMode = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StepperComponent.prototype, "layoutAlign", {
        /** The layout alignment of the stepper. */
        get: function () {
            return this._foundation.layoutAlign;
        },
        set: function (value) {
            this._foundation.layoutAlign = value;
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        FoundationProperty()
    ], StepperComponent.prototype, "disabled", void 0);
    __decorate([
        FoundationProperty()
    ], StepperComponent.prototype, "vertical", void 0);
    StepperComponent = __decorate([
        CustomElement({
            name: STEPPER_CONSTANTS.elementName,
            dependencies: [StepComponent]
        })
    ], StepperComponent);
    return StepperComponent;
}(HTMLElement));
export { StepperComponent };
